import style from 'components/Banner.module.scss'
import { Cross } from 'components/Icons'
import { formatMarkdown } from 'lib/helpers'
import React, { useState } from 'react'

const Banner = ({ banner, onDismiss }) => {
  const handleClick = () => {
    onDismiss(true)
  }

  return (
    <div className={style.root}>
      <div className={style.content}>
        <div
          className={style.message}
          dangerouslySetInnerHTML={{
            __html: formatMarkdown(banner.content.content),
          }}
        />
        <button
          onClick={handleClick}
          type="button"
          aria-label="Close banner"
          className={style.button}
        >
          <Cross />
        </button>
      </div>
    </div>
  )
}

export default Banner
